import { NS } from "../../static/constants";

// ----------------

const TYPE_NAME = "UI";

export const RESTORE_BRANCH = `${NS}/${TYPE_NAME}/RESTORE_BRANCH`;
export const TOGGLE         = `${NS}/${TYPE_NAME}/TOGGLE`;
